import { ModalService } from '../../components/modal/modal.service';
import { Icon } from '../../components/icon';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MChild, type MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import type { ReleaseNote, ReleaseNoteSection } from './release.notes.types';
import { CSS, Style } from './release.notes.popup.style';

addStyles(Style);

const ALL_RELEASE_NOTES_URL = 'https://ikegps.zendesk.com/hc/en-us/categories/16992245574541-Release-Notes';

function formatReleaseDate(iso: string): string {
	const [year, month, day] = iso.split('-').map(Number);
	if (year == null || month == null || day == null) {
		return iso;
	}
	return new Date(year, month - 1, day).toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
}

function viewSection(section: ReleaseNoteSection): MithrilVNode {
	return m('div', { className: CSS.section }, [
		m('div', { className: CSS.sectionHeading }, section.heading),
		m(
			'ul',
			{ className: CSS.sectionList },
			section.items.map((item) => m('li', { className: CSS.sectionItem }, item))
		),
	]);
}

function viewRelease(release: ReleaseNote): MithrilVNode {
	const children: MChild[] = [
		m('div', { className: CSS.releaseHeading }, `v${release.version} (${formatReleaseDate(release.date)})`),
	];
	if (release.description != null) {
		children.push(m('div', { className: CSS.releaseDescription }, release.description));
	}
	if (release.sections != null) {
		for (const section of release.sections) {
			children.push(viewSection(section));
		}
	}
	return m('div', { className: CSS.release }, children);
}

function viewContent(): MithrilVNode {
	const children: MChild[] = [];
	for (const release of Services.ReleaseNotes.releases) {
		children.push(viewRelease(release));
	}
	children.push(
		m(
			'a',
			{
				className: CSS.allReleaseNotes,
				href: ALL_RELEASE_NOTES_URL,
				target: '_blank',
				rel: 'noopener noreferrer',
			},
			Translate(T.ALL_RELEASE_NOTES)
		)
	);
	return m('div', children);
}

export const ReleaseNotesPopup = {
	open(): Promise<void> {
		void Services.ReleaseNotes.markAsViewed();
		return ModalService.open({
			title: Translate(T.RELEASE_NOTES),
			titleIcon: Icon.view(MaterialIcon.DESCRIPTION),
			className: CSS.modal,
			content: viewContent,
			canClose: () => true,
		}).then(() => undefined);
	},
};
